export const TM_AUTOSIZE_IGNORE_CLASS = 'ignore-hidden' as const
export const TM_AUTOSIZE_CHILDREN_VIEWER_HIDDEN_ATTR = 'data-tm-auto-size-children-viewer-hidden' as const
